// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"100":"forgot-password","710":"buyer-registration","966":"login"}[chunkId] || chunkId) + "." + {"100":"63950572","268":"5bac138e","710":"421535c8","822":"943826f6","966":"a82aba45"}[chunkId] + ".js";
};